import { runTypeFromSlug } from '@flux/shared';
import { createRoute, useParams } from '@tanstack/react-router';
import type { JSX } from 'react';
import { NotFoundPage } from '@/components/error-boundary/not-found-page.js';
import { FulfillmentRunDetailPage } from '@/features/runs/fulfillment-run-detail.js';
import { PennylaneRunDetailPage } from '@/features/runs/pennylane-run-detail.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/journal/runs/$type/$id` — détail d'un run (`02` §11). Une page dédiée
 * plutôt qu'un tiroir : c'est la cible des liens profonds des emails
 * d'alerte (`alerts/routes.ts::APP_ROUTES.fulfillmentRun` /
 * `.pennylaneRun`), qui doivent rester valides et partageables.
 *
 * `$type` est le segment français (`suivi-martelet`, `pennylane`) —
 * `runTypeFromSlug` de `@flux/shared` est la seule table de correspondance.
 * Le retour vers l'onglet Runs est un lien de l'en-tête de chaque détail
 * (`features/runs/run-detail-layout.tsx::RUNS_BACK_LINK`).
 */
function RunDetailRoute(): JSX.Element {
  const params: { type?: string; id?: string } = useParams({ strict: false });
  const type = runTypeFromSlug(params.type ?? '');
  const id = params.id ?? '';

  if (type === null || id === '') {
    return <NotFoundPage />;
  }

  return type === 'fulfillment' ? (
    <FulfillmentRunDetailPage runId={id} />
  ) : (
    <PennylaneRunDetailPage runId={id} />
  );
}

export const journalRunDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/journal/runs/$type/$id',
  component: RunDetailRoute,
});
